export default class CrossProduct {
  #htmlDOMElement;
  #cartManager;
  #addToCartButton;
  #boundAddToCartHandler;

  constructor(element, cartManager) {
    this.#htmlDOMElement = element;
    this.#cartManager = cartManager;

    if (!this.#htmlDOMElement) {
      return;
    }

    this.getHTMLDOMElements();
    this.initEvents();
  }

  getHTMLDOMElements() {
    this.#addToCartButton =
      this.#htmlDOMElement.querySelector("[data-add-to-cart]");
  }

  initEvents() {
    if (this.#addToCartButton) {
      this.#boundAddToCartHandler = this.onAddToCartButtonClick.bind(this);
      this.#addToCartButton.addEventListener(
        "click",
        this.#boundAddToCartHandler,
      );
    }
  }

  async onAddToCartButtonClick() {
    let id = this.#addToCartButton.dataset.addToCart;
    try {
      const response = await this.#cartManager.addToCart(
        this.#addToCartButton,
        id,
      );

      console.info("response", response);

      if (response.success) {
        this.handleSuccessfulAddToCart(response);
      } else {
        this.handleFailedAddToCart(response);
      }
    } catch (error) {
      this.handleFailedAddToCart(error);
    }
  }

  handleSuccessfulAddToCart(response) {
    console.log("Product successfully added to cart", response);
    this.hide();
  }

  handleFailedAddToCart(error) {
    console.error("Failed to add product to cart", error);
    // Tutaj możesz dodać dodatkową logikę, np. wyświetlenie komunikatu o błędzie
  }

  hide() {
    if (this.#htmlDOMElement) {
      // animation to hide the product
      this.#htmlDOMElement.style.transition = "all 0.8s ease";
      this.#htmlDOMElement.style.opacity = 0;
      // translate to right
      this.#htmlDOMElement.style.transform = "translateX(100%)";

      setTimeout(() => {
        this.#htmlDOMElement.style.display = "none";
        this.destroy();
      }, 850);
    }
  }

  destroy() {
    if (this.#addToCartButton && this.#boundAddToCartHandler) {
      this.#addToCartButton.removeEventListener(
        "click",
        this.#boundAddToCartHandler,
      );
    }
    this.#boundAddToCartHandler = null;
    this.#addToCartButton = null;
    this.#htmlDOMElement = null;
    this.#cartManager = null;
  }
}
